import { IntegrationType } from "@/gql/graphql";
import JucyLogoSvg from "@/app/Settings/Integrations/Jucy/Icons/JucyLogoSvg";
import RcmLogoSvg from "@/app/Settings/Integrations/Rcm/Icons/RcmLogoSvg";
import GoogleSheetsLogoSvg from "@/app/Settings/Integrations/GoogleSheets/Icons/GoogleSheetsLogoSvg";
import { CarFront, FileSpreadsheet } from "lucide-react";
import { FC } from "react";

type Integration = {
  type: IntegrationType;
  name: string;
  description: string;
  logo: FC<any>;
};
export const integrations: Integration[] = [
  {
    type: IntegrationType.Jucy,
    name: "Jucy",
    description: "Enable integration to automate booking requests",
    logo: JucyLogoSvg,
  },
  {
    type: IntegrationType.Rcm,
    name: "RCM",
    description: "Sync relocations with your rental car manager system",
    logo: RcmLogoSvg,
  },
  {
    type: IntegrationType.Camperman,
    name: "Camperman",
    description:
      "Enable integration to automate pull relocations from a spreadsheet",
    logo: FileSpreadsheet,
  },
  {
    type: IntegrationType.CampermanGapFiller,
    name: "Camperman Gap Filler",
    description:
      "Enable integration to automate pull gap filler relocations from a spreadsheet",
    logo: FileSpreadsheet,
  },
  {
    type: IntegrationType.Roadsurfer,
    name: "Roadsurfer",
    description: "Pull roadsurfer's own deal sheet and list the trips it holds",
    logo: FileSpreadsheet,
  },
  {
    type: IntegrationType.Click4Wheels,
    name: "Click4Wheels",
    description: "Place Europcar Australia bookings in Click4Wheels",
    logo: CarFront,
  },
  {
    type: IntegrationType.GoogleSheets,
    name: "Google Sheets",
    description:
      "Pull relocations from a Google Sheet and trigger imports via a sharable link",
    logo: GoogleSheetsLogoSvg,
  },
];
